import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentHeaderFooter } from '../../model/content/contentheaderfooter.model';
import { ContentPrimaryNavigation } from '../../model/content/contentprimarynavigation.model';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-links-content-mobile-container',
  templateUrl: 'app-links-content-mobile-container.component.html'
})
export class AppLinksContentMobileContainerComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() selectedItem;
  @Input() highlightOnlyFirstItem: boolean;
  @Input() isSlimHeader = false;
  @Input() isMobileDevice: boolean;
  @Output() navItemClicked: EventEmitter<string> = new EventEmitter();
  @Input() isloggedIn = false;
  checkInWidget = 'check_in';

  public mainNav: ContentPrimaryNavigation[];
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private loggingService: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    const content = new ContentHeaderFooter();
    if (content.header.primaryNavigations) {
      this.mainNav = Array.from(content.header.primaryNavigations.values());
    }
  }

  ngOnInit() {
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                if (data.header.primaryNavigations) {
                  this.mainNav = Array.from(
                    data.header.primaryNavigations.values()
                  );
                }
                this.cdf.detectChanges();
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  selecedtNavItem(
    widgetId,
    legacyAppUrl = '',
    redirectMobile = '',
    redirectMobileUrl = ''
  ) {
    if (this.isSlimHeader) {
      if (isPlatformBrowser(this.platformId)) {
        window.location.href = legacyAppUrl;
      }
    } else if (
      this.isMobileDevice &&
      redirectMobile !== '' &&
      redirectMobile.toLowerCase() === 'true' &&
      redirectMobileUrl !== ''
    ) {
      window.location.href = redirectMobileUrl;
    } else {
      this.selectedItem = widgetId;
      this.navItemClicked.emit(widgetId);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedItem) {
      if (
        ['book', 'check_in', 'my_trips', 'flightstatus'].indexOf(
          this.selectedItem
        ) === -1
      ) {
        this.navItemClicked.emit('-1');
      }
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }
}
